import { Avatar } from "@productlane/ui"

import type { TimelineEventProps } from "./types"
import { SystemEvent } from "./base/system-event"

export function ThreadCreatedEvent({
	event,
	hasEventAbove = false,
	hasEventBelow = false,
}: TimelineEventProps) {
	if (event.type !== "createdAt" || event.thread.origin !== "INAPP") {
		return null
	}

	const creatorName = event.thread.creatorName

	return (
		<SystemEvent
			icon={
				<Avatar
					name={creatorName ?? "?"}
					image={event.thread.creatorImage ?? null}
					size="xxs"
					roundness="full"
				/>
			}
			timestamp={new Date(event.thread.createdAt)}
			hasEventAbove={hasEventAbove}
			hasEventBelow={hasEventBelow}
		>
			<span className="truncate text-tertiary">
				{creatorName ? `${creatorName} created this thread` : "Thread created"}
			</span>
		</SystemEvent>
	)
}
